// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__RiEDO","status":"style_status__xZ6aL","report":"style_report__skREk","actions":"style_actions__4RMgN","actions_btn":"style_actions_btn__3+Gxz"};